// extracted by mini-css-extract-plugin
module.exports = {"iconArrowDown":"IconArrowDown_iconArrowDown__3dlwT","selected":"IconArrowDown_selected__WgHgJ"};